import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/site/LegalPage";
import { legalPages } from "@/content/legal";
import { SITE_URL } from "@/lib/seo";

const d = "How Leadership Edge Live collects, uses, and protects your personal data.";

export const Route = createFileRoute("/privacy-policy")({
  head: () => ({
    links: [{ rel: "canonical", href: `${SITE_URL}/privacy-policy/` }],
    meta: [
      { title: "Privacy Policy | Leadership Edge Live" },
      { name: "description", content: d },
      { property: "og:title", content: "Privacy Policy | Leadership Edge Live" },
      { property: "og:description", content: d },
      { property: "og:type", content: "article" },
    ],
  }),
  component: () => <LegalPage title="Privacy Policy" blocks={legalPages["privacy-policy"]} />,
});
